import to from 'await-to-js';
import OKA from '../';

import _get from 'lodash/get';
import config from '@root/config';

import { formatRequest } from '@libs/discovery';

export default {
    GetPractitioner: (slug) => new Promise(async(resolve, reject) => {
        if (!OKA.http.discovery) reject(false);
        if (slug) {
            const [err, response] = await to(OKA.http.discovery.get(`/practitioner/?slug=${slug}`));
            if (err) {
                reject(err)
            }

            resolve(response);
        }

        reject(new Error('slug not found'))
    }),

    GetIpByCountry: () => new Promise(async(resolve, reject) => {
        if (!OKA.http.discovery) reject(false);
        const [err, response] = await to(OKA.http.discovery.post('/master/ip2location'));
        if (err) {
            reject(err);
        } else {
            resolve(response);
        }
    }),
    GetInitialData: (facility) => new Promise(async(resolve, reject) => {
        if (!OKA.http.discovery) reject(false);
        const query = {
            "hitsPerPage": 100,
            "page": 1,
            "analytics": false,
            "attributesToRetrieve": "*",
            "getRankingInfo": true,
            "responseFields": "*",
            "facets": [
                "locations.id",
                "countryCode",
                "gender",
                "languages",
                "locations.area",
                "locations.idx",
                "locations.insuranceLocal.name",
                "locations.insuranceLocal.plans",
                "plan",
                "published",
                "searchSpec",
                "speciality",
                "speciality_title",
                "verified"
            ],
            "facetFilters": [
                [
                    "plan:2"
                ],
                [
                    "published:true"
                ]
            ]
        };
        query.facetFilters.unshift([`locations.id:${facility}`]);

        let [err, response] = await to(OKA.http.discovery.post(`/search/indexes/${config.doctor_index}/query`, {
            params: formatRequest(query)
        }));
        if (err) {
            reject(err);
        } else {
            const data = _get(response, 'data') || false;
            resolve({
                data
            });
        }

    })
}